const common = {
    no_data: 'Veri bulunamadı',
    header: {
        business_name: 'İşletmeniz'
    },
    download_app: {
        text: 'Simply web sürümünü kullanmak için lütfen dizüstü bilgisayar veya masaüstü bilgisayar kullanın.',
        button: 'Mobil sürümü indir'
    },
    unknown: 'Bilinmiyor',
    request_error: 'Bir hata oluştu. Lütfen tekrar deneyin! Veya sorununuzu bildirmek için müşteri desteğine başvurun.',
    home: 'Ana Sayfa',
    dashboard: 'Kontrol Paneli',
    product: 'Ürün',
    add_product: 'Ürün Ekle',
    edit_product: 'Ürünü Düzenle',
    stock_in: 'Stok Giriş',
    Sales_Turnover: 'Satış Ciro',
    profit: 'Kâr',
    stock_out: 'Stok Çıkış',
    staff: 'Personel',
    stock_audit: 'Stok Sayımı',
    button: {
        save: 'Kaydet',
        save_and_add_more: 'Kaydet & Yeni Ekle',
        submit: 'Gönder',
        done: 'Tamam',
        edit: 'Düzenle',
        save_edit: 'Değişiklikleri Kaydet',
        yes: 'Evet',
        clear: 'Temizle',
        delete: 'Sil',
        cancel: 'İptal',
        reset: 'Sıfırla'
    },
    select_date: 'Tarih Seç',
    select_action: 'İşlem Seç',
    mandatory: ' *(Zorunlu)',
    not_mandatory: '(Zorunlu Değil)',
    business: 'İşletme',
    account: 'Hesap',
    profile: 'Profil',
    setting: 'Ayarlar',
    whichLanguage: 'Türkçe',
    headerDashboard: 'VIP Ol',
    contact_us: 'Bize Ulaşın',
    logout: 'Çıkış Yap',
    category: 'Kategori',
    add_category: 'Kategori Ekle',
    data: 'Veri',
    history: 'Geçmiş',
    lowStockAlert: 'Düşük Stok Uyarısı',
    Expenses: 'Giderler',
    lowStockAlertButton: 'Güvenlik Stoğu Miktarı Ekle',
    message: {
        login_success: 'Başarıyla Giriş Yapıldı!',
        onboard_success: 'Yaşasın!! Yolculuğunuz başladı!',
        successfully_saved: 'Veri başarıyla kaydedildi',
        successfully_deleted: 'Veri başarıyla silindi',
        error_required_field: 'Zorunlu alan boş bırakılamaz',
        no_access: 'Erişim yok',
        no_permission: 'İzniniz yok',
        error_update_history: 'Geçmiş güncellenemedi'
    },
    no_permission_dialog: {
        title: 'İzin Yok',
        description: 'Giderleri görüntüleme izniniz yok. Lütfen yöneticinizle iletişime geçin.'
    },
    feedback: 'Geri Bildirim Ver',
    contact: 'İletişim',
    add: 'Ekle',
    supplier: 'Tedarikçi',
    customer: 'Müşteri',
    random: 'Rastgele',
    scan: 'Tarama',
    enter: 'Barkod tarayarak giriş yap',
    terms: {
        text: 'Devam ederek kabul etmiş olursunuz:',
        link: 'Gizlilik Politikası'
    },
    others: 'Diğerleri',
    calender: {
        presets: {
            today: 'Bugün',
            yesterday: 'Dün',
            last_7_days: 'Son 7 Gün',
            last_30_days: 'Son 30 Gün',
            this_month: 'Bu Ay',
            last_month: 'Geçen Ay',
            custom_range: 'Özel Aralık'
        }
    },
    print_large: 'Büyük Yazdır (A4)',
    print_letter: 'Letter Yazdır (US)',
    print_dot_matrix: 'Büyük Yazdır (Dot Matrix)',
    print_medium: 'Orta Yazdır (75mm)',
    print_small: 'Küçük Yazdır (48mm)',
    format: 'Kağıt Formatı',
    preview: 'Önizleme',
    view_invoice: 'Fatura',
    view_chalan: 'İrsaliye',
    price: 'Fiyat',
    stock: 'Stok',
    quantity: 'Miktar',
    total: 'Toplam',
    print_footer_left: 'Oluşturan',
    print_footer_center: 'Yazdırılma tarihi',
    print_footer_date: 'tarihinde',
    print_to: 'Alıcı',
    language: 'Türkçe',
    dateStatus: 'Son 7 Gün',
    placeholder: 'İşlem Türü',
    staffHistory: 'Personel Seç',
    languageTitle: 'Türkçe',
    date: 'Tarih',
    download: 'İndir',
    download_excel: 'Excel İndir',
    download_pdf: 'Barkod İndir',
    currentTitle: 'Para Birimi',
    Selectperiod: 'Dönem seç',
    TransactionType: 'İşlem Türü',
    SelectCustomer: 'Müşteri Seç',
    invoice: 'Fatura',
    login: {
        google: 'Google ile Giriş Yap',
        apple: 'Apple ile Giriş Yap'
    },
    trusted_by: {
        title: 'Endonezya genelinde 50.000\'den fazla işletme tarafından güveniliyor 🇮🇩'
    },
    privacyPolicyOne: "Giriş yaparak Simply'nin",
    privacyPolicyTwo: 'Gizlilik Politikası',
    manufacture: 'Üretim',
    warehouse: 'Depolar',
    error: {
        title: 'Hay aksi! Bir şeyler ters gitti',
        description: 'Beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin veya ana sayfaya dönün.',
        refresh: 'Sayfayı Yenile',
        go_back: 'Ana Sayfaya Dön',
        not_found: 'Sayfa Bulunamadı'
    },
    totalPurchasePrice: 'Toplam Satın Alma Fiyatı',
    pageTotalPurchaseAmount: 'Sayfa Toplam Satın Alma Tutarı',
    approval_status: 'Onay durumu',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    select_fields: 'Alanları Seç',
    syncWithTally: 'Tally ile Senkronize Et',
    importFromTally: "Tally'den İçe Aktar",
    exportToTally: "Tally'ye Dışa Aktar",
    All: 'Tümü',
    Approval: 'Onay'
}
export default common